import { extend } from './utils';
import base from './base';

export default extend(base, {
  backgroundPrimary: '#fff',
  backgroundSecondary: '#f1f4f8',
  backgroundHover: '#f1f4f8',
  textPrimary: '#495057',
  textSecondary: '#1b1d25',
  blockquoteBackground: '#edf2ff',
  highlight: '#fff176',
});